import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateBookingSteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateEventSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Click the Create Booking option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.BOOKING}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 23 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="Enter a Booking Name and add the booking details such as meeting link, date, duration, and description."
          type="create booking"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.FORM.FORM}"]`,
      ],
      position: 'left',
      stepInteraction: false,
      styles: {
        popover: (base) => ({ ...base, marginRight: 10 }),
      },
    },
    {
      content: 'Click Save, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.BOOKING.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8 }),
      },
    },
  ];

  const showQuickCreateBookingSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateEventSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateBookingSteps;
};

export default useGetHowToQuickCreateBookingSteps;
